import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b9f8c7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor-header" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "group-menu-item" }
const _hoisted_8 = { class: "arrow-btn" }
const _hoisted_9 = {
  class: "github-link",
  href: "https://github.com/pipipi-pikachu/PPTist",
  target: "_blank"
}
const _hoisted_10 = { class: "menu-item" }

import { nextTick, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import useScreening from '@/hooks/useScreening'
import useImport from '@/hooks/useImport'
import useSlideHandler from '@/hooks/useSlideHandler'
import type { DialogForExportTypes } from '@/types/export'

import HotkeyDoc from './HotkeyDoc.vue'
import FileInput from '@/components/FileInput.vue'
import FullscreenSpin from '@/components/FullscreenSpin.vue'
import Drawer from '@/components/Drawer.vue'
import Input from '@/components/Input.vue'
import Popover from '@/components/Popover.vue'
import PopoverMenuItem from '@/components/PopoverMenuItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { title } = storeToRefs(slidesStore)
const { enterScreening, enterScreeningFromStart } = useScreening()
const { importSpecificFile, importPPTXFile, exporting } = useImport()
const { resetSlides } = useSlideHandler()

const mainMenuVisible = ref(false)
const hotkeyDrawerVisible = ref(false)
const editingTitle = ref(false)
const titleInputRef = ref<InstanceType<typeof Input>>()
const titleValue = ref('')

const startEditTitle = () => {
  titleValue.value = title.value
  editingTitle.value = true
  nextTick(() => titleInputRef.value?.focus())
}

const handleUpdateTitle = () => {
  slidesStore.setTitle(titleValue.value)
  editingTitle.value = false
}

const goLink = (url: string) => {
  window.open(url)
  mainMenuVisible.value = false
}

const setDialogForExport = (type: DialogForExportTypes) => {
  mainStore.setDialogForExport(type)
  mainMenuVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_IconHamburgerButton = _resolveComponent("IconHamburgerButton")!
  const _component_IconPpt = _resolveComponent("IconPpt")!
  const _component_IconDown = _resolveComponent("IconDown")!
  const _component_IconDownload = _resolveComponent("IconDownload")!
  const _component_IconGithub = _resolveComponent("IconGithub")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Popover, {
        trigger: "click",
        placement: "bottom-start",
        value: mainMenuVisible.value,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((mainMenuVisible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(FileInput, {
            accept: ".pptist",
            onChange: _cache[0] || (_cache[0] = files => {
            _unref(importSpecificFile)(files)
            mainMenuVisible.value = false
          })
          }, {
            default: _withCtx(() => [
              _createVNode(PopoverMenuItem, null, {
                default: _withCtx(() => [
                  _createTextVNode("导入 pptist 文件")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(FileInput, {
            accept: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            onChange: _cache[1] || (_cache[1] = files => {
            _unref(importPPTXFile)(files)
            mainMenuVisible.value = false
          })
          }, {
            default: _withCtx(() => [
              _createVNode(PopoverMenuItem, null, {
                default: _withCtx(() => [
                  _createTextVNode("导入 pptx 文件（测试版）")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(PopoverMenuItem, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setDialogForExport('pptx')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出文件")
            ]),
            _: 1
          }),
          _createVNode(PopoverMenuItem, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_unref(resetSlides)(); mainMenuVisible.value = false})
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置幻灯片")
            ]),
            _: 1
          }),
          _createVNode(PopoverMenuItem, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (goLink('https://github.com/pipipi-pikachu/PPTist/issues')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("意见反馈")
            ]),
            _: 1
          }),
          _createVNode(PopoverMenuItem, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (goLink('https://github.com/pipipi-pikachu/PPTist/blob/master/doc/Q&A.md')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("常见问题")
            ]),
            _: 1
          }),
          _createVNode(PopoverMenuItem, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => {mainMenuVisible.value = false; hotkeyDrawerVisible.value = true})
          }, {
            default: _withCtx(() => [
              _createTextVNode("快捷键")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_IconHamburgerButton, { class: "icon" })
          ])
        ]),
        _: 1
      }, 8, ["value"]),
      _createElementVNode("div", _hoisted_4, [
        (editingTitle.value)
          ? (_openBlock(), _createBlock(Input, {
              key: 0,
              class: "title-input",
              ref_key: "titleInputRef",
              ref: titleInputRef,
              value: titleValue.value,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((titleValue).value = $event)),
              onBlur: _cache[9] || (_cache[9] = ($event: any) => (handleUpdateTitle()))
            }, null, 8, ["value"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "title-text",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (startEditTitle())),
              title: _unref(title)
            }, _toDisplayString(_unref(title)), 9, _hoisted_5))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "menu-item",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(enterScreening)()))
        }, [
          _createVNode(_component_IconPpt, { class: "icon" })
        ])), [
          [_directive_tooltip, '幻灯片放映']
        ]),
        _createVNode(Popover, {
          trigger: "click",
          center: ""
        }, {
          content: _withCtx(() => [
            _createVNode(PopoverMenuItem, {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(enterScreeningFromStart)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("从头开始")
              ]),
              _: 1
            }),
            _createVNode(PopoverMenuItem, {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(enterScreening)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("从当前页开始")
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_IconDown, { class: "arrow" })
            ])
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "menu-item",
        onClick: _cache[14] || (_cache[14] = ($event: any) => (setDialogForExport('pptx')))
      }, [
        _createVNode(_component_IconDownload, { class: "icon" })
      ])), [
        [_directive_tooltip, '导出']
      ]),
      _createElementVNode("a", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_IconGithub, { class: "icon" })
        ])
      ])
    ]),
    _createVNode(Drawer, {
      width: 320,
      visible: hotkeyDrawerVisible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((hotkeyDrawerVisible).value = $event)),
      placement: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(HotkeyDoc)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(FullscreenSpin, {
      loading: _unref(exporting),
      tip: "正在导入..."
    }, null, 8, ["loading"])
  ]))
}
}

})